import TableFailedCodes from '../components/TableFailedCodes';

const FailedTransfer = () => (
  <div>
    <TableFailedCodes />
  </div>
);

export default FailedTransfer;
